<div class="task-dialog" role="dialog" aria-modal="true">
  <!-- Header -->
  <div class="task-dialog__header">
    <h2 class="task-dialog__title">{{ title() }}</h2>

    <button type="button" class="task-dialog__icon-btn" aria-label="Close dialog" (click)="cancel()">✕</button>
  </div>

  <!-- Content -->
  <div class="task-dialog__content">
    <div class="task-dialog__section-title">Activity Details</div>

    <form class="task-dialog__form" [formGroup]="form">
      <!-- Program select -->
      <div class="task-dialog__row">
        <div class="field">
          <dr-ops-stream-ui-app-dropdown
            id="activity"
            formControlName="activity"
            [searchable]="true"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            placeholder="Activity Type"
            [closeOnOutsideClick]="true"
            [options]="activityOptions()"
            floatingLabel="Activity Type"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

          @if (form.controls.activity.touched && form.controls.activity.invalid) {
            <div class="field__error">Activity Type is required</div>
          }
        </div>
        <div class="field">
          <!-- <label class="field__label" for="program">Program</label> -->

          <dr-ops-stream-ui-app-dropdown
            id="program"
            formControlName="programId"
            [searchable]="true"
            [disabled]="isViewOnly()"
            [disabledOpacity]="1"
            placeholder="Program"
            [closeOnOutsideClick]="true"
            [options]="programOptionsWithOther()"
            floatingLabel="Program"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>

        </div>
      </div>
      <!-- Notes -->
      <div class="field field--full">
        <!-- <label class="field__label" for="notes">Notes</label> -->
        <textarea id="notes" class="textarea" formControlName="notes" placeholder="Add notes" rows="4" [readOnly]="isViewOnly()"></textarea>
      </div>

      @if (!isCreate()) {
        <span class="task-dialog__section-title">Set up date and time</span>

        <div class="task-dialog__row">
          <div class="field">
            <input id="dueDate" class="input" type="datetime-local" formControlName="dueDate" placeholder="Date and time" [readOnly]="isViewOnly()" />
            @if (form.controls.dueDate.touched && form.controls.dueDate.invalid) {
              <div class="field__error">Date/time is required</div>
            }
          </div>
          <dr-ops-stream-ui-app-dropdown
            id="timezone"
            formControlName="timezone"
            [disabledOpacity]="1"
            placeholder="Timezone"
            [closeOnOutsideClick]="true"
            [options]="utcOnlyOptions"
            floatingLabel="Timezone"
            [panelMaxHeightRem]="24"
          ></dr-ops-stream-ui-app-dropdown>
        </div>
      }
    </form>
  </div>

  <!-- Footer -->
  <div class="task-dialog__footer">
    <button type="button" class="btn btn--secondary" (click)="cancel()">Cancel</button>

    @if (!isViewOnly()) {
      <button type="button" class="btn btn--primary" [disabled]="!canSubmit()" (click)="submit()">{{ confirmLabel() }}</button>
    }
  </div>
</div>
